import rawConfig from 'envConfig';
import { parseEnvConfig, type EnvConfig } from './env-config-schema';

export const config: EnvConfig = parseEnvConfig(rawConfig);
